

import { useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";
import DSInput from "components/DSInput";
import DSButton from "components/DSButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import curved9 from "assets/images/curved-images/curved-6.jpg";

import { useAuth } from "../../../auth-context/auth.context";
//import AuthApi from "../../../api/auth";

import { useHistory } from "react-router-dom";

function SignIn() {
  const history = useHistory();
  const { setUser } = useAuth();
  const { user } = useAuth();

  const [rememberMe, setRememberMe] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(undefined);
  const [buttonText, setButtonText] = useState("Sign in");
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const login = async (event) => {
    if (event) {
      event.preventDefault();
    }
    if (user && user.token) {
      return history.push("/dashboard");
    }
    if (email === "") {
      return setError("You must enter your email.");
    }
    if (password === "") {
      return setError("You must enter your password");
    }
    setButtonText("Signing in");
    try {
      /*let response = await AuthApi.Login({
        email,
        password,
      });
      if (response.data && response.data.success === false) {
        return setError(response.data.msg);
      }*/
      return setProfile();
    } catch (err) {
      console.log(err);
      setButtonText("Sign in");
      if (err.response) {
        return setError(err.response.data.msg);
      }
      return setError("There has been an error.");
    }
  };

  const setProfile = async () => {
    let user = { _id: "user1", username: "username1", email: "user@mail.com" };
    user.token = "abc";
    user = JSON.stringify(user);
    setUser(user);
    localStorage.setItem("user", user);
    return history.push("/dashboard");
  };

  return (
    <CoverLayout
      title="Datanet Studio Dashboard"
      description={`${user && user.token ? "" : "Enter your email and password to sign in --- (Please Use login  'admin' and password  'admin' for demo)"} `}
    //style={{background: "linear-gradient(310deg, rgba(33, 82, 255, 0.6), rgba(33, 212, 253, 0.6)), url()"}}
    >
      {user && user.token ? (
        <div>
          <h3 style={{ textAlign: "center" }}>You are already signed in.</h3>
          <DSBox mt={4} mb={1}>
            <DSButton variant="gradient" buttonColor="info" fullWidth onClick={login}>
              {`Let's go`}
            </DSButton >
          </DSBox >
        </div >
      ) : (
        <DSBox component="form" role="form">
          <DSBox mb={2}>
            <DSBox mb={1} ml={0.5}>
              <DSTypography component="label" variant="caption" fontWeight="bold">
                Email (admin)
              </DSTypography>
            </DSBox>
            <DSInput
              defaultValue={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setError(undefined);
              }}
              type="email"
              placeholder="Email"
            />
          </DSBox>
          <DSBox mb={2}>
            <DSBox mb={1} ml={0.5}>
              <DSTypography component="label" variant="caption" fontWeight="bold">
                Password (admin)
              </DSTypography>
            </DSBox>
            <DSInput
              defaultValue={password}
              onChange={(event) => {
                setPassword(event.target.value);
                setError(undefined);
              }}
              type="password"
              placeholder="Password"
            />
          </DSBox>
          <DSBox display="flex" alignItems="center">
            <Switch checked={rememberMe} onChange={handleSetRememberMe} />
            <DSTypography
              variant="button"
              fontWeight="regular"
              onClick={handleSetRememberMe}
              customClass="cursor-pointer user-select-none"
            >
              &nbsp;&nbsp;Remember me
            </DSTypography>
          </DSBox>
          <DSBox mt={2} mb={2} textAlign="center">
            <h6
              style={{
                fontSize: ".8em",
                color: "red",
                textAlign: "center",
                fontWeight: 400,
                transition: ".2s all",
              }}
            >
              {error}
            </h6>
          </DSBox>

          <DSBox mt={4} mb={1}>
            <DSButton variant="gradient" buttonColor="info" fullWidth onClick={login}>
              {buttonText}
            </DSButton>
          </DSBox>
          <DSBox mt={3} textAlign="center">
            <DSTypography variant="button" textColor="text" fontWeight="regular">
              Don&apos;t have an account?{" "}
              <DSTypography
                component={Link}
                to="/authentication/sign-up"
                variant="button"
                textColor="info"
                fontWeight="medium"
                textGradient
              >
                Sign up
              </DSTypography>
            </DSTypography>
          </DSBox>
        </DSBox>
      )}
    </CoverLayout >
  );
}

export default SignIn;
